"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getContactsFilters = exports.getContactsPagination = exports.getContactById = exports.getContactsIsLoaded = exports.getContactsIsLoading = exports.getContactsCount = exports.getContactsList = exports.getContactsState = void 0;

var R = _interopRequireWildcard(require("ramda"));

var _reselect = require("reselect");

var _root = require("../root.selector");

var getContactsState = (0, _reselect.createSelector)(_root.getCreateGiftState, function (state) {
  return state.contacts;
});
exports.getContactsState = getContactsState;
var getContactsList = R.compose(R.prop('contacts'), getContactsState);
exports.getContactsList = getContactsList;
var getContactsCount = R.compose(R.length, getContactsList);
exports.getContactsCount = getContactsCount;
var getContactsIsLoading = R.compose(R.prop('isLoading'), getContactsState);
exports.getContactsIsLoading = getContactsIsLoading;
var getContactsIsLoaded = R.compose(R.prop('isLoaded'), getContactsState);
exports.getContactsIsLoaded = getContactsIsLoaded;

var getContactById = function getContactById(state) {
  return function (contactId) {
    return R.compose(R.find(function (contact) {
      return contact.id === contactId;
    }), getContactsList)(state);
  };
};

exports.getContactById = getContactById;
var getContactsPagination = (0, _reselect.createSelector)(getContactsState, R.prop('pagination'));
exports.getContactsPagination = getContactsPagination;
var getContactsFilters = (0, _reselect.createSelector)(getContactsState, R.prop('filters'));
exports.getContactsFilters = getContactsFilters;